var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChpOne(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 61 61",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "chpOne"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30.14,
    cy: 30.126,
    r: 29.946,
    style: {
      fill: "#4888ad"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.715,48.231c-0,-0 -13.974,-2.043 -11.364,-16.41c0.489,-6.009 3.036,-11.54 8.397,-16.415c0.322,5.643 1.071,9.332 2.269,10.974c1.541,-8.489 5.136,-17.162 13.344,-21.926c-1.319,2.258 -2.155,6.147 -1.545,9.212c0.341,1.714 1.496,4.969 3.219,7.851c3.531,5.908 1.218,8.593 2.181,8.508c2.209,-3.446 2.575,-6.239 2.393,-9.203c2.923,3.502 3.971,7.396 2.938,17.057c-1.412,7.226 -5.366,11.307 -11.746,12.387l-9.873,-2.037l13.374,-14.068l-5.885,-0.008l5.393,-13.792l-15.382,16.329l4.993,-0.019l-2.706,11.56Z",
    style: {
      fill: "#fff",
      stroke: "#0070ff",
      strokeWidth: "0.5px"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChpOne);
export default __webpack_public_path__ + "static/media/chpOne.b39042d0a9e9d0acdd7758f8d7064fa7.svg";
export { ForwardRef as ReactComponent };